/**
 * Рамочное выделение без встроенного rubberband X6 (он с panning/документ-событиями даёт «ничего не выделяется»).
 * При активном режиме panning должен быть выключен.
 *
 * @param {import('@antv/x6').Graph} graph
 * @param {import('@antv/x6').Selection} selectionPlugin
 * @returns {() => void} cleanup
 */
export function installBoxSelectMode(graph, selectionPlugin) {
	const RUBBER_CLS = 'canvas-x6-box-select-rubber';

	const onBlankMouseDown = ({e, x, y}) => {
		if (!e || e.button !== 0) return;

		const clientX = e.clientX;
		const clientY = e.clientY;
		const localStart = {x, y};

		const band = document.createElement('div');
		band.className = RUBBER_CLS;
		band.setAttribute('aria-hidden', 'true');
		Object.assign(band.style, {
			position: 'fixed',
			left: `${clientX}px`,
			top: `${clientY}px`,
			width: '0',
			height: '0',
			border: '1px dashed #1677ff',
			background: 'rgba(22, 119, 255, 0.08)',
			pointerEvents: 'none',
			zIndex: '10000',
			boxSizing: 'border-box',
		});
		document.body.appendChild(band);

		const onMove = ev => {
			const left = Math.min(ev.clientX, clientX);
			const top = Math.min(ev.clientY, clientY);
			band.style.left = `${left}px`;
			band.style.top = `${top}px`;
			band.style.width = `${Math.abs(ev.clientX - clientX)}px`;
			band.style.height = `${Math.abs(ev.clientY - clientY)}px`;
		};

		const onUp = ev => {
			document.removeEventListener('mousemove', onMove, true);
			document.removeEventListener('mouseup', onUp, true);
			if (band.parentNode) {
				band.parentNode.removeChild(band);
			}

			const pEnd =
				typeof graph.clientToLocal === 'function'
					? graph.clientToLocal(ev.clientX, ev.clientY)
					: {x: localStart.x, y: localStart.y};
			const x0 = Math.min(localStart.x, pEnd.x);
			const y0 = Math.min(localStart.y, pEnd.y);
			const w = Math.abs(pEnd.x - localStart.x);
			const h = Math.abs(pEnd.y - localStart.y);
			const MIN = 4;
			if (w < MIN && h < MIN) {
				if (typeof selectionPlugin.clean === 'function') {
					selectionPlugin.clean();
				}
				return;
			}
			const nodes =
				typeof graph.getNodesInArea === 'function'
					? graph.getNodesInArea(x0, y0, w, h, {strict: false})
					: [];
			if (nodes.length && typeof selectionPlugin.reset === 'function') {
				selectionPlugin.reset(nodes, {batch: true});
			} else if (typeof selectionPlugin.clean === 'function') {
				selectionPlugin.clean();
			}
		};

		document.addEventListener('mousemove', onMove, true);
		document.addEventListener('mouseup', onUp, true);
	};

	graph.on('blank:mousedown', onBlankMouseDown);

	return () => {
		graph.off('blank:mousedown', onBlankMouseDown);
	};
}
